<template>
  <div>
    <Header :image="storeInfo.image">
      {{ storeInfo.name }}
    </Header>
    <main id="#main">
      <h2 class="c-level2">
        <span>
          ご予約確認
        </span>
      </h2>
      <div class="c-card-default">
        <h3 class="c-level3">
          ご予約内容
        </h3>
        <ul class="c-defList">
        <li>
          <dl>
            <dt>予約日時</dt>
            <dd>
              <p>{{displayFullYear(tempReservation.date)}}年{{displayMonth(tempReservation.date)}}月{{displayDate(tempReservation.date)}}日</p>
              <p>
                {{ tempReservation.startAt }}〜{{ tempReservation.endAt }}
              </p>
              </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>メニュー</dt>
            <dd>
              <p v-for="(menu, menuIndex) in tempReservation.menus" :key="menuIndex">{{ menu.name }}：¥{{ menu.price.toLocaleString() }}</p>
              <p class="c-price__total">合計：¥{{ sumPrice(tempReservation.menus).toLocaleString() }}</p>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>氏名</dt>
            <dd>
              <p>{{ reserveInfo.name }}</p>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>よみがな</dt>
            <dd>
              <p>{{ reserveInfo.yomi }}</p>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>電話番号</dt>
            <dd>
              <p>{{ reserveInfo.tel }}</p>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>お知らせ</dt>
            <dd>
              <p v-if="reserveInfo.mailPermission">お知らせを受け取る</p>
              <p v-else>お知らせを受け取らない</p>
            </dd>
          </dl>
        </li>
      </ul>
      <p class="c-text__notice--center u-mt30">
      <router-link tag="a" :to="{ path: '/terms'}" target="_blank">利用規約</router-link>、<a @click="openBlankLink('/privacy')">プライバシーポリシー</a> に同意して
      </p>
      <p class="c-btn--primary" @click="clickReserveBtn()">
        予約を確定する
      </p>
      <router-link tag="p" :to="{ name: 'reservation', params: {} }" class="c-btn--tertiary c-btn--small u-mt10">
        情報を修正する
      </router-link>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { mapState, mapActions } from 'vuex'
import { Mixin } from '@/mixin'

export default {
  name: 'app',
  components: {
    Header,
    Footer
  },
  head: {
    title: function () {
      return {
        inner: this.storeInfo.name,
        separator: '|',
        complement: '予約確認'
      }
    }
  },
  computed: {
    ...mapState({
      storeInfo: 'storeInfo',
      tempReservation: 'tempReservation',
      reserveInfo: 'reserveInfo'
    })
  },
  beforeRouteEnter (route, redirect, next) {
    next(async vm => {
      const promises = []
      vm.$store.commit('SET_LOADING', true)
      promises.push(vm.$store.dispatch('LOAD_STORE_INFO', { storeid: route.params.storeid }))
      await Promise.all(promises).then(function () {
        vm.$emit('updateHead')
        vm.$store.commit('SET_LOADING', false)
      }).catch(function (error) {
        vm.$store.commit('SET_LOADING', false)
        alert(error.message)
      })
    })
  },
  mixins: [Mixin],
  methods: {
    ...mapActions(['LOAD_STORE_INFO', 'LOAD_MENU_INFO']),
    openBlankLink: function (url) {
      const routeData = this.$router.resolve({ path: url })
      window.open(routeData.href, '_blank')
    },
    clickReserveBtn: async function () {
      const promises = []
      const that = this
      const payload = this.reserveInfo
      payload.id = this.$route.params.rsvid
      this.$store.commit('SET_LOADING', true)
      promises.push(this.$store.dispatch('SEND_RESERVATION', payload))
      await Promise.all(promises).then(function () {
        that.$store.commit('SET_LOADING', false)
        that.$router.push({ path: '/' + that.$route.params.storeid + '/finish/' })
      }).catch(function (error) {
        that.$store.commit('SET_LOADING', false)
        alert(error.message)
      })
    }
  }
}
</script>
